module.exports = __webpack_public_path__ + "static/media/feature2.5a1dc357.png";